import React from "react";
import { Route } from "react-router-dom";

import ForgotPassword from "cortex/ui/src/view/auth/ForgotPassword";
import Login from "cortex/ui/src/view/auth/Login";
import Logout from "cortex/ui/src/view/auth/Logout";
import Register from "cortex/ui/src/view/auth/Register";
import ResetPassword from "cortex/ui/src/view/auth/ResetPassword";

function renderAuthRoutes() {
  return [
    <Route component={Login} exact key="login-view" path="/login" />,
    <Route
      component={ForgotPassword}
      exact
      key="forgot-password-view"
      path="/login/forgot-password"
    />,
    <Route
      component={ResetPassword}
      exact
      key="reset-password-view"
      path="/login/reset-password"
    />,
    <Route component={Logout} exact key="logout-view" path="/logout" />,
    <Route
      component={Register}
      exact
      key="user-register"
      path={["/register", "/register/:id"]}
    />,
  ];
}

export { renderAuthRoutes };
